import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTWCL_SorryX_this_game_is_not_availa_ELL } from './Unsupported.messages.json';
import styles from './Unsupported.scss';

const Unsupported = () => (
  <div className={styles.container}>
    <p className={styles.big}>
      ⚠️ <Translation {...TXTWCL_SorryX_this_game_is_not_availa_ELL} />
    </p>
  </div>
);
export default Unsupported;
